import { createSelector } from '@reduxjs/toolkit';

import { JsonQueryFilters } from 'shared/types/JsonQuery';
import { ListingSortType } from 'shared/types/ListingSortType';

import { useReduxSelector } from '../../../external/hooks';

import { jsonQuerySelector } from './root';

export const listingSortSelector = createSelector(jsonQuerySelector, state => state.sort);
export function useListingSortSelector(): ListingSortType {
  return useReduxSelector(listingSortSelector);
}

export const filtersSelector = createSelector(jsonQuerySelector, state => state.filters);
export function useFiltersSelector(): JsonQueryFilters {
  return useReduxSelector(filtersSelector);
}

export const pageSelector = createSelector(jsonQuerySelector, state => state.page);
export function usePageSelector(): number {
  return useReduxSelector(pageSelector);
}
